import type { IDxgVehicle } from '@makemydeal/dr-shared-types';
import type { DealVersionChangeType } from '@makemydeal/dr-shared-bff-types';
import { Actions } from '../actionTypes/actionTypes';

/**
 * @param navigateOnSuccess route to navigate to once the save comes back successfully. Use this
 * when a save is the user's commitment to move on (e.g. picking a vehicle) so navigation waits for
 * the server instead of running optimistically and stranding the user somewhere on a failed save.
 * @param changeType explicit changeType for this save, e.g. DEAL_SETUP from the Deal Setup screen's
 * Launch Deal. When omitted, the middleware falls back to its own derivation (see UPDATE_DEAL case).
 */
export const updateDealAction = (
    selectedDxgVehicle: IDxgVehicle,
    navigateOnSuccess?: string,
    changeType?: DealVersionChangeType
) => {
    return {
        type: Actions.UPDATE_DEAL,
        payload: {
            selectedDxgVehicle,
            changeType
        },
        meta: { navigateOnSuccess }
    };
};

export const onDealsFetched = (dealCount: number) => {
    return {
        type: Actions.DEALS_FETCHED,
        payload: { dealCount }
    };
};
